module.exports = __webpack_public_path__ + "gfx/WTRZ-01.png";